import { onLoad } from "@/utils/onLoad";

export default ({ app }) => {
  onLoad(() => {
    const script = document.createElement("script");
    script.defer = true;
    script.src = "https://animaapp.s3.amazonaws.com/static/an2.js";

    document.head.appendChild(script);
  });
};
